import RequestEstimatePass from 'routes/Requests/RequestEstimatePass';
import RequestEstimate from '../routes/Requests/RequestEstimate';
import RequestOrder from '../routes/Requests/RequestOrder';

const requestRoutes = [
  {
    path: 'requests',
    children: [
      {
        path: 'order',
        element: <RequestOrder />,
      },
      {
        path: 'estimate',
        element: <RequestEstimate />,
      },
      {
        path: 'estimate/pass',
        element: <RequestEstimatePass />,
      },
    ],
  },
];

export default requestRoutes;
